import React, { useState, useEffect } from "react";
import "./ViewLoanDetails.css";
import { AiOutlineTable } from "react-icons/ai";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import LoanDetails from "./Components/LoanDetails/LoanDetails";
import LoanSchedule from "./Components/LoanSchedule/LoanSchedule";
import NomineeDetails from "./Components/NomineeDetails/NomineeDetails";
import Foreclosed from "./Components/Foreclosed/Foreclosed";
import Sidebar from "../../../Sidebar/Sidebar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Cookies from "js-cookie";

// import { BsCash } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
// import { HiDocument } from "react-icons/hi";
// import { BiTrash } from "react-icons/bi";
import Charges from "./Components/Charges/Charges";
import Payable from "./Components/Payable/Payable";
// import NonDeductableCharge from "./Components/NonDeductableCharge/NonDeductableCharge";
import axios from "axios";
import { url } from "../../../App";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import { BorrowerContextProvider } from "../../Borrower/BorrowerDetails/store/borrower-details";
import Lenders from "./Components/Lenders/Lenders";

export const fixDateHandler = (dateField) => {
  if (!dateField) {
    return "N/A";
  }
  const apiDate = dateField.split("T")[0];
  const formattedDate = apiDate.split("-");
  // console.log(formattedDate)
  return `${formattedDate[2]}-${formattedDate[1]}-${formattedDate[0]}`;
};

const ViewLoanDetails = () => {
  // const cpanel = axios.create({ baseURL: url });
  const [value, setValue] = useState("1");
  const [isOpen, setIsOpen] = useState(true);
  const [loanTerms, setLoanTerms] = useState({});
  const [loanArr, setLoanArr] = useState([]);
  const [loader, setLoader] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [showData, setshowData] = useState(false);
  const Navigate = useNavigate();
  const openView = (val) => setIsOpen(val);
  const location = useLocation();
  const loanData = location.state;

  const openLoader = () => {
    setLoader(true);
  };

  const closeLoader = () => {
    setLoader(false);
  };

  const fixDateHandler = (dateField) => {
    if (!dateField) {
      return "N/A";
    }
    const apiDate = dateField.split("T")[0];
    const formattedDate = apiDate.split("-");
    // console.log(formattedDate)
    return `${formattedDate[2]}-${formattedDate[1]}-${formattedDate[0]}`;
  };

  const arrayLengthHandler = (array) => {
    // console.log(array)
    if (!array) {
      return "N/A";
    }
    const arrLength = array.length;
    // console.log(arrLength)
    return arrLength;
  };

  const tabSelectHandler = (event, newValue) => {
    setValue(newValue);
  };

  const EMAIL = Cookies.get("Email");
  const TOKEN = Cookies.get("Token");

  const permissionHandler = async () => {
    try {
      const request = {
        email: EMAIL,
        token: TOKEN,
        useremail: EMAIL,
      };
      const { data } = await axios.post(url + "/user/getsingle", request);
      if (!data.auth) {
        toast.error(data.message);
      }
      if (EMAIL === "rupesh.bishnoi@credin.in") {
        const permissionProxy = new Proxy(
          {},
          {
            get: function (target, prop) {
              return true;
            },
          }
        );
        setPermissions(permissionProxy);
        return;
      }
      setPermissions(data[0].permission);
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const loanTermsAPI = async () => {
      try {
        setLoader(true);
        // const refTokenReq = {
        //   token: TOKEN,
        //   email: EMAIL,
        // };
        // const { data: refToken } = await axios.post(
        //   url + "/user/tokenrefresh",
        //   refTokenReq
        // );
        // if (refToken.logout) {
        //   toast.error(refToken.message);
        //   setTimeout(() => {
        //     Navigate("/");
        //   }, 2000);
        // }
        // localStorage.setItem("Token", refToken.token);

        const req = {
          // token: refToken.token,
          token: TOKEN,
          email: Cookies.get("Email"),
          loan_id: loanData.loan_id,
        };
        const res = await axios.post(url + "/loan/getloanterms", req);
        if (res.data.logout === true) {
          // Navigate("/");
          setLoader(false);
        }
        if (!res.data.auth) {
          // toast.error(res.data.message);
          return;
        }
        setLoanTerms(res.data.message);
        setLoanArr(res.data.message.loan_fees_arr);
        setLoader(false);
      } catch (err) {
        console.error(err);
        setLoader(false);
        return null;
      }
    };
    permissionHandler();
    loanTermsAPI();
    axios
      .post(url + "/loan/foreclosed", {
        email: Cookies.get("Email"),
        token: TOKEN,
        loan_id: loanData.loan_id,
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === true) {
          setshowData(false);
        } else {
          setshowData(true);
        }
      })
      .catch((err) => {
        // console.log(err);
        // toast.error(err.message);
      });
    // eslint-disable-next-line
  }, [loanData]);

  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h2 className="main-heading">
              <AiOutlineTable />
              View Loan Details
            </h2>
            <button
              onClick={() => Navigate(`/borrower/detail/${loanData.loan_id}`)}
              className="backIcon"
            >
              <ArrowBackIcon sx={{ fontSize: "28px" }} />
            </button>
            <div className="lms-table-div view-loandetails">
              <table className="lms-table">
                <thead>
                  <tr>
                    <th>Borrower</th>
                    <th>Loan#</th>
                    <th>Product</th>
                    <th>Amount</th>
                    <th>Interest</th>
                    {/* <th>Plan ID</th> */}
                    {/* <th>Status</th> */}
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{loanData?.borrower_name}</td>
                    <td>{loanData?.loan_id}</td>
                    <td>{loanData?.loanproduct_name}</td>
                    <td>{loanData?.loan_principal_amt}</td>
                    <td>{loanData?.loanproduct_interest_rate}</td>
                    {/* <td>??</td>
                    </td> */}
                  </tr>
                </tbody>
              </table>
            </div>
            <button className="loan-officer-btn">Loan Officer</button>
            <div className="tabs-div">
              {/* <Tabs activeTab= {activeTab} onSelectTab = {tabSelectHandler} tabs={tabs} /> */}
              <TabContext value={value}>
                <div className="tab-header">
                  <TabList
                    onChange={tabSelectHandler}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                  >
                    {permissions.loan_terms_loan_details && (
                      <Tab label="Loan Terms" value="1" />
                    )}
                    {permissions?.add_loan_document ||
                    permissions?.view_loan_document ||
                    permissions?.download_loan_document ? (
                      <Tab label="Insurance Details" value="3" />
                    ) : (
                      ""
                    )}
                    {permissions.loan_schedule_loan_details && (
                      <Tab label="Loan Schedule" value="2" />
                    )}
                    {permissions.foreclosure_details_loan_details && (
                      <Tab disabled={showData} label="Foreclosed" value="4" />
                    )}
                    {permissions.charges_loan_details && (
                    <Tab label="Charges" value="5" />
                    )}
                    <Tab disabled label="Refund" value="6" />
                    {permissions.view_ki_score && (
                      <Tab label="Lenders" value="7" />
                    )}
                    {/* <Tab disabled label="Non Deductable Charge" value="7" /> */}
                  </TabList>
                </div>
                <TabPanel value="1">
                  {permissions.loan_terms_loan_details && (
                    <LoanDetails
                      loanData={loanData}
                      loanDetails={loanTerms}
                      dateFunction={fixDateHandler}
                      arrayLength={arrayLengthHandler}
                      loanArr={loanArr}
                    />
                  )}
                </TabPanel>
                <TabPanel value="2">
                  <LoanSchedule loanData={loanData} />
                </TabPanel>
                <TabPanel value="3">
                  {permissions.add_loan_document ||
                  permissions.view_loan_document ||
                  permissions.download_loan_document ? (
                    <BorrowerContextProvider>
                    <NomineeDetails
                      loanData={loanData}
                      openLoader={openLoader}
                      closeLoader={closeLoader}
                      permissions={permissions}
                    />
                     </BorrowerContextProvider>
                  ) : (
                    ""
                  )}
                </TabPanel>
                <TabPanel value="4">
                  <Foreclosed loanData={loanData} />
                </TabPanel>
                <TabPanel value="5">
                  <Charges loanData={loanData}/>
                </TabPanel>
                <TabPanel value="6">
                  <Payable />
                </TabPanel>
                <TabPanel value="7">
                  {/* <NonDeductableCharge /> */}
                  <Lenders loanData={loanData} />
                </TabPanel>
              </TabContext>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewLoanDetails;
